import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SettingsService } from "src/app/core/settings";

// navigator.share needs a fresh click, which the ~8s PDF conversion uses up, so the user clicks Share here.
@Component({
  selector: "ls-whatsapp-share",
  templateUrl: "./whatsapp-share.component.html",
})
export class WhatsAppShareComponent {
  @Input() file: File;
  cdnUrl: string = "";
  constructor(
    public activeModal: NgbActiveModal,
    private settingsService: SettingsService,
  ) {
    this.cdnUrl = settingsService.getSettings().cdnBaseUrl;
  }

  async share(): Promise<void> {
    try {
      // Browsers can't target WhatsApp directly; the OS share sheet lists it when installed.
      await navigator.share({ files: [this.file] });
      this.activeModal.close();
    } catch (error) {
      // AbortError means the user closed the share sheet; keep the modal open so they can retry or download
      if ((error as DOMException)?.name !== "AbortError") {
        console.error(error);
      }
    }
  }

  download(): void {
    const data = window.URL.createObjectURL(this.file);
    const link = document.createElement("a");
    link.href = data;
    link.download = this.file.name;
    link.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
      this.activeModal.close();
    }, 100);
  }
}
